<div class="max-w-2xl mx-auto">
  @if (!isMainSettingsPage()) {
    <a
      routerLink="/settings"
      class="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-4 transition-colors">
      <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
      {{ 'settings.back' | translate }}
    </a>
  }
  <router-outlet />
</div>
